<div [class]="!bgLight ? 'lds-ring' : 'lds-ring inverse'" [hidden]="loading">
  <mat-spinner [diameter]="50" class="button-spinner dark"></mat-spinner>
  <p>{{text}}</p>
</div>
<div id="spinner-overlay" [class]="getOverlayStyles()" [hidden]="loading"></div>
